export default () => ({
  choosingTeam: false,
  checkingTokenExpired: false,
  departments: [],
  gettingDepartments: false,
  gettingTeams: false,
  gettingUser: false,
  logging: false,
  resending: false,
  sendingForgetPwdLink: false,
  settingPassword: false,
  team: localStorage.getItem('team') || null,
  teams: [],
  token: localStorage.getItem('_t') || '',
  updatingUser: false,
  user: {},
});
